import img1 from '../../static/img/class_types_page/rooftop_low_impact_dance_workout.webp';
import img2 from '../../static/img/class_types_page/dancing_low_impact_workout_class.webp';
import quoteImg from '../../static/img/class_types_page/Quote_love_how_you_feel_dance_fitness.webp';

const Class = {
  code: 'nia',
  name: 'The Nia Dance Class',
  sentence1: 'Each Nia class experience combines music, mindfulness and dynamic movement to leave you physically energized, mentally clear, and emotionally balanced. Nia workouts combine 52 simple moves with dance arts, martial arts, and healing arts to energize and enliven well-being in 60 minutes - body, mind, emotion, and spirit. Nia is non-impact, practiced barefoot, and adaptable to individual needs and abilities.',
  sentence2: 'Love your class and want to deepen your practice on and off the dance floor? Find a Nia Body + Life Training.',
  quoteSentence1: 'Nia is my go to workout for my body, mind and soul. Love that it is a practice - like yoga or meditation - and that it not only helps me stay in shape but it helps me... show up as the person I want to be in the world.',
  quoteSentence2: '',
  quoteAttr: 'Caroline Kohles, Nia Trainer',
  img1,
  img2,
  quoteImg,
  img1Alt: 'A group of people on a rooftop participating in one of Nia\'s low impact dance workout classes',
  img2Alt: 'A group of people participating in one of Nia\'s low impact dance workout classes',
  quoteAlt: 'A quote that says "love how you feel with Nia" to illustrate how fun Nia\'s low impact dance fitness classes are',
};

export default Class;
